<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item prop="name">
        <el-select
          v-model="queryParams.name"
          placeholder="卡源名称"
          clearable
        >
          <el-option
              v-for="item in source"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="operationName">
        <el-select v-model="queryParams.operationName" placeholder="选择运营商">
          <el-option label="中国移动" value="中国移动"></el-option>
          <el-option label="中国联通" value="中国联通"></el-option>
          <el-option label="中国电信" value="中国电信"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="groupId">
        <el-input v-model="queryParams.groupId" placeholder="群组ID"></el-input>
      </el-form-item>
      <el-form-item prop="groupName">
        <el-input v-model="queryParams.groupName" placeholder="池名称"></el-input>
      </el-form-item>
      <el-form-item prop="share">
        <el-select v-model="queryParams.share" placeholder="池模式" clearable>
          <el-option label="普通池" value="0"></el-option>
          <el-option label="共享池" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border v-loading="loading" >
      <el-table-column type="index" label="序号" align="center" width="80px"></el-table-column>
      <el-table-column prop="name" label="卡源名称" align="center" width="120px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
            <span>{{scope.row.name}}</span>
            <span>{{scope.row.operationName}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="groupId" label="池编号" align="center" min-width="150" :show-overflow-tooltip="true">
        <template slot-scope="scope">
            <!-- 使用 div 容器并设置 flex 布局 -->
          <div style="display: flex; align-items: center;">
            <!-- 显示池编号，设置 flex-grow 让内容自动填充剩余空间 -->
            <el-link 
              type="primary" 
              :underline="false" 
              @click="info(scope.row)"
              style="flex-grow: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 4px;"
            >
              {{ scope.row.groupId }}
            </el-link>
            <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
              <i style="font-size:16px;" class="el-icon-document-copy" @click="copy(scope.row.groupId)"></i>
            </el-tooltip>
          </div>
          <span v-if="!!scope.row.apnName">APN：{{scope.row.apnName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="groupName" label="池名称" align="center" min-width="130" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <!-- 使用 div 容器并设置 flex 布局 -->
          <div style="display: flex; align-items: center;">
            <!-- 显示池名称，设置 flex-grow 让内容自动填充剩余空间 -->
            <span style="flex-grow: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 4px;">{{scope.row.groupName}}</span>
            <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
              <i style="font-size:16px;" class="el-icon-document-copy" @click="copy(scope.row.groupName)"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="共享" align="center" width="120px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
            <span>{{ scope.row.share =='1'?'是':'否' }}</span>
            <span v-if="scope.row.share =='1'">{{ scope.row.shareFlow }} MB</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="monthFlow" label="平台池用量MB" align="center" min-width="120">
        <template slot-scope="scope">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
            <span>{{scope.row.monthFlow}}</span>
            <span v-if="scope.row.pool == '1'"><span style="color: #1890ff;">{{ (scope.row.monthFlow - scope.row.operatorMonthFlow).toFixed(2)}}</span>/误差</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="syncNum" label="同步卡数/h" align="center"></el-table-column>
      <el-table-column prop="totalNum" label="池总卡数" align="center"></el-table-column>
      <el-table-column prop="activeNum" label="激活卡数" align="center">
        <template slot="header">
          <span>激活卡数</span>
          <el-tooltip class="item" effect="dark" content="平台运营状态激活卡数" placement="top">
            <i class="el-icon-question" style="margin-left: 4px;"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
            <span>{{scope.row.activeNum}}</span>
            <span v-if="scope.row.operatorActiveNum != '0'">{{scope.row.operatorActiveNum}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="invalidNum" label="无效卡数" align="center">
        <template slot="header">
          <span>无效卡数</span>
          <el-tooltip class="item" effect="dark" content="平台展示状态为销户和预销户卡数，下面一行为有效卡数" placement="top">
            <i class="el-icon-question" style="margin-left: 4px;"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
            <span>{{scope.row.invalidNum}}</span>
            <span><span style="color: #ff4d4f;">{{scope.row.totalNum - scope.row.invalidNum}}</span>/有效</span>

          </div>
        </template>
      </el-table-column>
      <!-- 自动转换为KB GB  -->
      <el-table-column prop="operatorMonthFlow" label="运营商池用量MB" align="center" min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.pool == '0'">无群组接口</span>
          <span v-else>{{scope.row.operatorMonthFlow}}</span>
        </template>
      </el-table-column>
       <el-table-column prop="updateTime" label="成功同步/同步时间" align="center" min-width="140">
        <template slot-scope="scope">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%;">
            <span>{{scope.row.lastSuccessTime}}</span>
            <span>{{scope.row.updateTime}}</span>
          </div>
        </template>
       </el-table-column>
      <el-table-column prop="status" label="同步状态" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.status =='1'">成功</el-tag>
            <el-tag v-else type="warning">失败</el-tag>
          </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex; flex-direction: column;">
            <el-link  icon="el-icon-refresh" type="primary" :underline="false" @click="refresh(scope.row)" >刷新</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { cardSourceFlowList,cardSource,sourceFlowRefresh } from "@/api/api.js"; //获取卡源流量列表
export default {
  name: "sourceFlow",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 搜索
      queryParams:{
        name:undefined,
        groupName:undefined,
        share:undefined,
        groupId:undefined,
        operationName:undefined,

      },
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      // 来源
      source: [],
    };
  },
  computed: {},
  methods: {
    // 获取列表
    initData() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize
      };
      this.loading = true;
      cardSourceFlowList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
        this.loading = false;
      });
    },
    handleQuery(){
      this.page = 1,
      this.initData();
    },
    resetQuery(){
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 刷新 */
    refresh(row) {
      sourceFlowRefresh({
        id:row.id
      }).then(res => {
        this.initData();
      });
    },
    //查找卡源列表
    handleCardSource(){
      cardSource().then(res => {
        this.source = res.data.data;
      });
    },
    info(item){
      this.$router.push('/card/groupCard/' + item.groupId);
    },
    //复制数据
    copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
            message: '复制成功',
            type: 'success',
            duration:1000
        });
        oInput.remove()
    },
    
  },
  mounted() {
  },
  created(){
    this.initData();
    this.handleCardSource();
  }
};
</script>
<style scoped lang="less">
  .table-expand{
    margin-left: 20px;
    label{
      width: 90px;
      color: #99a9bf; 
    }
    .el-form-item{
      margin-bottom: 0;
    }
  }
</style>


